import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import Container from 'react-bootstrap/Container';

const AccessState = ({
  title = 'Access Unavailable',
  message = 'You do not have permission to access this area.',
  actionLabel = 'Go Back',
  actionTo = null,
  onAction = null,
  autoRedirectTo = null,
  autoRedirectDelayMs = 0,
}) => {
  const navigate = useNavigate();
  const [secondsRemaining, setSecondsRemaining] = useState(
    autoRedirectTo && autoRedirectDelayMs > 0 ? Math.ceil(autoRedirectDelayMs / 1000) : 0
  );

  const handleAction = () => {
    if (typeof onAction === 'function') {
      onAction();
      return;
    }

    if (actionTo) {
      navigate(actionTo);
      return;
    }

    navigate(-1);
  };

  useEffect(() => {
    if (!autoRedirectTo || autoRedirectDelayMs <= 0) return undefined;

    const timeoutId = window.setTimeout(() => {
      navigate(autoRedirectTo);
    }, autoRedirectDelayMs);

    const intervalId = window.setInterval(() => {
      setSecondsRemaining((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => {
      window.clearTimeout(timeoutId);
      window.clearInterval(intervalId);
    };
  }, [autoRedirectDelayMs, autoRedirectTo, navigate]);

  return (
    <Card className="justify-content-md-center mt-5">
      <Container fluid="md">
        <h3>{title}</h3>
        <p>{message}</p>
        {autoRedirectTo && autoRedirectDelayMs > 0 && (
          <p>{`Redirecting in ${secondsRemaining} second${secondsRemaining === 1 ? '' : 's'}...`}</p>
        )}
        <Button label={actionLabel} icon="pi pi-arrow-left" onClick={handleAction} />
      </Container>
    </Card>
  );
};

export default AccessState;